import { render, staticRenderFns } from "./quality-list.vue?vue&type=template&id=0aab2f66&scoped=true"
import script from "./quality-list.vue?vue&type=script&lang=js"
export * from "./quality-list.vue?vue&type=script&lang=js"
import style0 from "./quality-list.vue?vue&type=style&index=0&id=0aab2f66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab2f66",
  null
  
)

export default component.exports